import ConsentManager from 'components/ConsentManager';
import React from 'react';

const ConsentPage: React.FC = () => <ConsentManager />;

export default ConsentPage;
